import { render, staticRenderFns } from "./AddDocumentsOld.vue?vue&type=template&id=50c2217d&scoped=true&lang=true&"
import script from "./AddDocumentsOld.vue?vue&type=script&lang=js&"
export * from "./AddDocumentsOld.vue?vue&type=script&lang=js&"
import style0 from "./AddDocumentsOld.vue?vue&type=style&index=0&id=50c2217d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c2217d",
  null
  
)

export default component.exports